export default __webpack_public_path__ + "static/akitabox_logo_hover.e94971401a6aef48e8d59da637bae1d3.svg";